import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { DebateTopicListItem } from "./DebateTopicListItem";
import { DebateTopicHeader } from "./DebateTopicHeader";
import { SelectBox } from "app/components/SelectBox";
import { Loading } from "app/components/Loading";
import { NoData } from "app/components/NoData";
import useQueryString from "utils/hooks/useQueryString";
import { Pagination } from "app/components/Pagination";
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";

const queryString = require("query-string");

export const DebateTopicList = () => {
    const navigate = useNavigate();
    const { school } = useParams();
    const auth = useSelector((state) => state.auth);
    const queryParams = useQueryString();
    const [inputSelected, setInputSelected] = useState("");

    const requestData = useMemo(() => {
        const paramJson = { page: 0, keyword: '' };
        return { ...paramJson, ...queryParams };
    }, [queryParams]);

    const { data: debateTopicList, isFetching, isError, error } = useQuery({
        queryKey: ['debate/topic/list', requestData],
        queryFn: () => Api.post(`/api/debate/topic/list?page=${requestData.page}`, requestData)
    });

    // 리스트 불러오기
    const gotoPage = (page = 0, options = {}) => {
        // 페이지 이동 시, 다른 parameter가 있을 때 같이 포함하여 리스트 불러오기
        let tempListOptions = { ...queryParams, ...options, page };
        navigate(
            `/${school}/debate?${queryString.stringify(
                tempListOptions
            )}`
        );
    };

    // 검색한 키워드 리스트 불러오기
    const handleSearchKeyword = (e, keyword) => {
        e.preventDefault();
        gotoPage(0, { keyword });
    };

    // 전체, 우리학교, 나의 리스트 불러오기
    const handleChangeSelectBox = (value) => {
        let tempListOptions = { ...queryParams, school: null, user: null };
        if (value === "school") tempListOptions.school = school;
        if (value === "user") tempListOptions.user = auth.id;
        gotoPage(0, tempListOptions);
    };

    // 토론 목록 출력하기
    const renderList = useMemo(() => {
        if(isError) return <div  className="no_data">{createFetchErrorMessage(error).message}</div>;
        if (debateTopicList?.data?.list.length <= 0)
            return (
                <NoData
                    title="독서 토론 주제"
                    desc="내가 직접 도서 상세 페이지에서 독서 토론 주제를 신청해보는건 어떨까요?"
                    url={`/${school}/book`}
                />
            );

        return debateTopicList?.data?.list.map((topic) => <DebateTopicListItem key={topic.id} topic={topic} />);
    }, [debateTopicList, error, isError, school]);

    return (
        <div className="debateTopicListPage">
            <DebateTopicHeader searchKeyword={handleSearchKeyword} />
            <div className="section p-tb-2">
                <div className="inner">
                    <div className="right">
                        <SelectBox
                            options={["🌏 전체", "🏫 우리학교", "😀 나"]}
                            values={["", "school", "user"]}
                            selected={inputSelected}
                            setSelected={setInputSelected}
                            fetchList={handleChangeSelectBox}
                        />
                    </div>
                    <ul>{renderList}</ul>
                    <Loading overlay={true} active={isFetching} />
                    <Pagination page={debateTopicList?.data?.page} totalPage={debateTopicList?.data?.totalPages} gotoPage={gotoPage}
                    />
                </div>
            </div>
        </div>
    );
};